import { Box, Grid } from '@material-ui/core';
import GridLayout, { Header, Body, Actions } from '../client/GridLayout';
import LoadingAnimation from '../controls/helpers/LoadingAnimation';
import { ReactComponent as LogoImage } from '../../images/nz-funds-nz-logo.svg';
import { Colors } from '../controls/helpers';

const LoadingScreen = ({ isNarrowView }: { isNarrowView?: boolean }) => {
    return <GridLayout isNarrowView={isNarrowView}>
        <Header isNarrowView={isNarrowView}>
            <Grid container alignItems="center">
                <LogoImage width={36} height={36} fill={Colors.Black} />&emsp;&emsp;
                Please wait...
            </Grid>
            &nbsp;
        </Header>
        <Body isNarrowView={isNarrowView}>
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                <LoadingAnimation />
            </Box>
        </Body>
        <Actions isNarrowView={isNarrowView}>
            <br />
        </Actions>
    </GridLayout>
}

export default LoadingScreen;
